import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronHollowDown = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M2.00002 12C2.00002 9.794 3.79402 8 6.00002 8C7.06802 8 8.07302 8.416 8.82802 9.171L16 16.343L23.172 9.171C23.928 8.416 24.932 8 26 8C28.206 8 30 9.794 30 12C30 13.068 29.584 14.073 28.828 14.828L18.828 24.828C18.072 25.584 17.068 25.999 15.999 25.999C14.93 25.999 13.926 25.583 13.17 24.827L3.17002 14.827C2.41402 14.071 1.99902 13.067 1.99902 11.998L2.00002 12ZM28 12C28 10.897 27.103 10 26 10C25.466 10 24.964 10.208 24.586 10.586L16.708 18.465C16.317 18.855 15.684 18.855 15.294 18.465L7.41502 10.586C7.03702 10.208 6.53502 10 6.00102 10C4.89802 10 4.00102 10.897 4.00102 12C4.00102 12.534 4.20902 13.036 4.58702 13.414L14.587 23.414C14.965 23.792 15.467 24 16.001 24C16.535 24 17.038 23.792 17.415 23.414L27.415 13.414C27.793 13.036 28.001 12.534 28.001 12H28Z" />
	</svg>
);

export default ChevronHollowDown;
